import { ReactComponent as FolderIcon } from 'assets/icons/folderIcon.svg';
import { ReactComponent as UpRight } from 'assets/icons/upRighticon.svg';
import { ReactComponent as MenuDots } from 'assets/icons/menudots.svg';
import { useState } from 'react';
import ReNameFolderOrFile from './renameFolder0rFile';
import DeleteSubFolderorFile from './deleteSubFoldersorFiles';
import { Popover } from '@mantine/core';
import dayjs from 'dayjs';

const ModalFoldersAndFilesTable = ({
  data,
  historyOfPath,
  setHistoryOfPath,
}) => {
  const [menuPopover, setMenuPopover] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [renameModal, setRenameModal] = useState(false);
  return (
    <>
      <tr>
        {data?.is_directory ? (
          <td>
            <div
              style={{ textAlign: 'start', paddingLeft: '40px' }}
              className='flex item-center gap-2 text-[#848383] cursor-pointer'
              onClick={() => setHistoryOfPath(`${historyOfPath}/${data?.name}`)}
            >
              <FolderIcon />
              {data?.name}
            </div>
          </td>
        ) : (
          <td>
            <div
              style={{ textAlign: 'start', paddingLeft: '40px' }}
              className='flex item-center gap-2 text-[#848383] cursor-pointer'
            >
              {data?.name}
            </div>
          </td>
        )}

        <td>
          <div className='flex  items-center justify-end pr-[40px] gap-3 '>
            <UpRight className='cursor-not-allowed opacity-50' />
            <Popover
              opened={menuPopover}
              onClose={() => setMenuPopover(false)}
              target={
                <MenuDots
                  className='h-5 w-5 cursor-pointer'
                  onClick={() => setMenuPopover((o) => !o)}
                />
              }
              width={150}
              position='right-start'
              classNames={{ body: 'rounded-lg' }}
            >
              <div className='flex flex-col '>
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setRenameModal(true);
                  }}
                >
                  Rename
                </p>
                <hr className='text-[#8E8E8E] opacity-50' />
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setOpenModal(true);
                  }}
                >
                  Delete
                </p>

                {/* <p className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'>
                  Pin to top
                </p> */}
              </div>
            </Popover>
          </div>
        </td>
        <td className='text-center text-[#848383]'>
          {dayjs.unix(data?.stat?.updated_time).format('DD MMM YYYY, hh:mm A')}{' '}
        </td>
        <td className='text-center text-[#848383]'>
          {data?.directory_values[0]?.updated_by__first_name}
        </td>
        {/* <td className='text-center text-[#848383] text-sm'>
          05 May 2022, 12:00(s)
        </td>
        <td className='text-center text-[#848383] text-sm'>
          Hugh Grant, UX designer(s)
        </td> */}
      </tr>
      <DeleteSubFolderorFile
        openModal={openModal}
        setOpenModal={setOpenModal}
        isDirectory={data?.is_directory}
        path={historyOfPath}
        name={data?.name}
      />
      <ReNameFolderOrFile
        isDirectory={data?.is_directory}
        path={historyOfPath}
        name={data?.name}
        renameModal={renameModal}
        setRenameModal={setRenameModal}
      />
    </>
  );
};

export default ModalFoldersAndFilesTable;
